export default __webpack_public_path__ + "static/media/pd-thumb.5f0185b5.png";